const MIN_INNERWIDTH = 770

const isDesktop = (innerwidth) => {
  return (innerwidth >= MIN_INNERWIDTH)
}

export default isDesktop
